module.exports = __webpack_public_path__ + "img/INSTAGRAM.21690208.svg";